import { render, staticRenderFns } from "./ntmCrop.vue?vue&type=template&id=4496240e"
import script from "./ntmCrop.vue?vue&type=script&lang=js"
export * from "./ntmCrop.vue?vue&type=script&lang=js"
import style0 from "./ntmCrop.vue?vue&type=style&index=0&id=4496240e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports